import PanelHeader from './PanelHeader';
import { PanelHeaderProps, PanelHeaderValueProps } from './types';

export type { PanelHeaderProps, PanelHeaderValueProps };
export default PanelHeader;
